import Cookies from 'js-cookie';

export const QS_PARAMS = 'hof.qs_params';

class HofCookie {
	/**
	 * @type {boolean}
	 */
	#cookieEnabled;

	/**
	 * @type {Partial<CookieAttributes>}
	 */
	#baseConfig = {
		path: '/',
		domain: currentDomainData.hostname,
	};

	/**
	 * @type {URLSearchParams}
	 */
	#store;

	constructor() {
		this.#cookieEnabled = navigator?.cookieEnabled || true;

		const decodedCookie =
			document.cookie?.trim() !== '' ? decodeURIComponent(document.cookie) : '';

		this.#store = new URLSearchParams(decodedCookie.split('; ').join('&'));

		this.#store.forEach((value, key) => {
			if (value.trim() === '') {
				this.#store.delete(key);
			}
		});

		this.set = this.set.bind(this);
		this.has = this.has.bind(this);
		this.get = this.get.bind(this);
		this.remove = this.remove.bind(this);
		this.replace = this.replace.bind(this);
	}

	/**
	 * @param {string} name
	 * @returns {boolean}
	 */
	has(name) {
		if (!this.#cookieEnabled) {
			return false;
		}
		return this.#store.has(name);
	}

	/**
	 * @param {string} name
	 * @returns {string|undefined}
	 */
	get(name) {
		return this.has(name) ? Cookies.get(name) : undefined;
	}

	/**
	 *
	 * @param {string} name
	 * @param {*} value
	 * @param {Partial<CookieAttributes>} options
	 * @returns {string|undefined|boolean}
	 */
	set(name, value, options = {}) {
		if (!this.#cookieEnabled) {
			return false;
		}
		if (typeof value === 'undefined') {
			return false;
		}

		this.#store.set(name, value);

		return Cookies.set(name, value, {
			...this.#baseConfig,
			expires: 7,
			sameSite: 'none',
			secure: true,
			...options,
		});
	}

	/**
	 * @param {string} name
	 * @param {Partial<CookieAttributes>} options
	 * @returns {void|boolean}
	 */
	remove(name, options = {}) {
		if (!this.#cookieEnabled) {
			return false;
		}

		this.#store.delete(name);

		return Cookies.remove(name, { ...this.#baseConfig, ...options });
	}

	/**
	 * @param {string} name
	 * @param {*} value
	 * @param {Partial<CookieAttributes>} options
	 */
	replace(name, value, options = {}) {
		this.remove(name);
		return this.set(name, value, options);
	}
}

const hofCookie = new HofCookie();

export default hofCookie;
